import { Button } from '@/components/design-system/Button';
import { ArrowLeft } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

export const NotFoundScreen: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleGoBack = () => {
    void navigate(-1);
  };

  return (
    <div className="flex h-screen items-center justify-center bg-white">
      <div className="flex flex-col items-center gap-4 text-center">
        <div className="flex flex-col gap-1">
          <h1 className="text-4xl font-semibold text-neutral-950">{t('notFound.title')}</h1>
          <p className="text-md text-neutral-400">{t('notFound.message')}</p>
        </div>
        <Button variant="outline" size="lg" onClick={handleGoBack}>
          <ArrowLeft className="size-4" />
          {t('notFound.goBack')}
        </Button>
      </div>
    </div>
  );
};
